import { render } from "./ConstructionalPraxisContent.vue?vue&type=template&id=65ba7070&scoped=true"
import script from "./ConstructionalPraxisContent.vue?vue&type=script&lang=js"
export * from "./ConstructionalPraxisContent.vue?vue&type=script&lang=js"

import "./ConstructionalPraxisContent.vue?vue&type=style&index=0&id=65ba7070&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ba7070"]])

export default __exports__